export const STATUS_PIX_COBRANCA_ATIVA = 'ATIVA'
export const STATUS_PIX_COBRANCA_CONCLUIDA = 'CONCLUIDA'
export const STATUS_PIX_COBRANCA_REMOVIDA_PELO_USUARIO_RECEBEDOR = 'REMOVIDA_PELO_USUARIO_RECEBEDOR'
export const STATUS_PIX_COBRANCA_REMOVIDA_PELO_PSP = 'REMOVIDA_PELO_PSP'



// WEBPACK FOOTER //
// ./src/domain/grv/helpers/pix.js